<div *ngIf="!enableScreen">
  <div *ngIf="!metadataLoaded" class="loadingOverlay">
    <div class="center-spinner-text center-loader">
      <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s"></p-progressSpinner>
      <p style="margin-top: 15px; color: #666;">Loading interview details...</p>
    </div>
  </div>

  <div *ngIf="metadataLoaded && (!verificationRequired || (mailVerified || mobileVerified) || meetingEnded)"
    class="get-verified">
    <div class="mediaAccess-overlay" *ngIf="!mediaAccess">
      <div class="mediaAccess">
        <img src="../../assets/icons-svg/Warning.svg" alt="Warning">
        <p class="warning">NOTE !</p>
        <p class="message">Kindly enable microphone and camera access in your browser.</p>
      </div>
    </div>
    
    <div *ngIf="isLoading" class="loadingOverlay center-loader">
      <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
      </p-progressSpinner>
    </div>
    <div *ngIf="!isLoading">
      <div *ngIf="!interviewStarted && !mediaAccessError" class="interview-wrapper">
        <div class="candidate-content">
          <div class="avatar-glow">
            <span>{{userInterviewData?.candidate_name?.charAt(0) || 'U'}}</span>
          </div>
      
          <h1 *ngIf="!meetingEnded" class="welcome-heading">
            Welcome, <span class="candidate-name">{{userInterviewData?.candidate_name || '-'}}</span>
          </h1>
      
          <div *ngIf="!validationError && !meetingEnded && !reloadInterview" class="status-badge">
            <i class="pi pi-clock"></i> Please wait until the interviewer allows you to join.
          </div>

          <div *ngIf="validationError && !meetingEnded && !reloadInterview" class="status-badge" style="background: #fdecea; color: #b71c1c;">
            <i class="pi pi-times-circle"></i> Verification failed. Please try again or contact admin.
          </div>

          <div *ngIf="meetingEnded && !reloadInterview" class="status-badge" style="background: #e8f5e9; color: #2e7d32;">
            <i class="pi pi-check-circle"></i> Your Interview has been completed.
            <div class="post-interview-message" style="margin-top: 10px; font-size: 14px;">
              Now you can close the panel and check your mail for further updates.
            </div>
          </div>

          <div *ngIf="reloadInterview" class="status-badge" style="background: #fffde7; color: #f57f17;">
            <i class="pi pi-refresh pi-spin"></i> Reloading interview...
          </div>

      
          <div class="instruction-container" *ngIf="!meetingEnded">
            <div class="instruction-heading">
              <i class="pi pi-info-circle instruction-icon"></i> MANDATORY INSTRUCTIONS:
            </div>
            <ul class="instruction-list">
              <li>
                <div class="instruction-number">1</div>
                <div>According to your browser settings, enable <strong>microphone</strong> and <strong>camera</strong> access before your interview starts.</div>
              </li>
              <li>
                <div class="instruction-number">2</div>
                <div>Kindly allow <strong>screenshare</strong> while joining interview.</div>
              </li>
              <li>
                <div class="instruction-number">3</div>
                <div>Avoid reloading/closing your interview screen during the interview. It will terminate the interview.</div>
              </li>
            </ul>
            <div class="warning-message">
              <i class="pi pi-exclamation-triangle warning-icon"></i> Do not refresh this page
            </div>
          </div>
      
          <button class="waiting-button" *ngIf="!meetingEnded && !validationError">
            Waiting for interviewer...
          </button>
      
          <div class="share-note" *ngIf="!meetingEnded && !validationError">
            <i class="pi pi-share-alt share-icon"></i> You'll be prompted to share your screen when the interviewer allows
          </div>
        </div>
      </div>
    
      <div *ngIf="mediaAccessError" class="interview-wrapper">
        <div class="candidate-content">
          <div class="avatar-glow">
            <i class="pi pi-exclamation-triangle" style="font-size: 28px;"></i>
          </div>
      
          <h1 class="welcome-heading">
            Media Access Required
          </h1>
      
          <div class="status-badge" style="background: #fdecea; color: #b71c1c;">
            <i class="pi pi-times-circle"></i> {{ mediaErrorMessage }}
          </div>

          <div class="instruction-container">
            <div class="instruction-heading">
              <i class="pi pi-info-circle instruction-icon"></i> HOW TO FIX:
            </div>
            <ul class="instruction-list">
              <li>
                <div class="instruction-number">1</div>
                <div>Check your browser's address bar for a camera/microphone icon</div>
              </li>
              <li>
                <div class="instruction-number">2</div>
                <div>Click on the icon and select "Allow" for both camera and microphone</div>
              </li>
              <li>
                <div class="instruction-number">3</div>
                <div>Refresh this page after allowing permissions</div>
              </li>
              <li>
                <div class="instruction-number">4</div>
                <div>If using Chrome, check Settings > Privacy and Security > Site Settings > Camera/Microphone</div>
              </li>
            </ul>
          </div>
      
          <button class="waiting-button" style="opacity: 1; cursor: pointer; background-color: #a78bfa;" (click)="retryMediaAccess()">
            <i class="pi pi-refresh" style="margin-right: 8px;"></i> Retry Media Access
          </button>
      
          <div class="share-note">
            <i class="pi pi-info-circle share-icon"></i> Make sure you're using a modern browser (Chrome, Firefox, Safari, Edge)
          </div>
        </div>
      </div>

      <button *ngIf="interviewStarted" pButton class="joinBtn" label="Open IDE" [loading]="loadIDE"
        (click)="openIDE()"></button>

      <div *ngIf="interviewStarted && hmsRoomUrl" class="hms-fullscreen-container">
        <iframe [src]="hmsRoomUrl" title="HMS interview room" allow="camera;microphone;fullscreen;display-capture;autoplay"
          class="hms-iframe"></iframe>
      </div>

      <div *ngIf="interviewStarted && !hmsRoomUrl" id="jaas-container" class="jitsi-container"
        [ngStyle]="{'display': interviewStarted ? 'block' : 'none' }">
      </div>
    </div>
  </div>

  <div class="verification-call"
    *ngIf="metadataLoaded && verificationRequired && (!mailVerified && !mobileVerified) && !meetingEnded">
    <app-otp-verification (mailVerified)="checkAndInitiate('mail', $event)"
      (candidateDetails)="checkAndInitiate('details', $event)" [candidateId]="userId" [emailToVerify]="candidateEmail"
      [stageId]="stageId" [eventId]="eventId" [interviewId]="interviewId"></app-otp-verification>
  </div>

  <button *ngIf="showCrispBtn"
          class="crisp-fab"
          (click)="openCrispChat()"
          type="button"
          title="Chat with Support"
          aria-label="Chat with Support">
    <i class="pi pi-comment"></i>
  </button>
</div>
<div *ngIf="enableScreen" class="loadingOverlay center-loader">
  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>